import React from 'react';
import classnames from 'classnames';

import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from 'buyside/components/presentation/Skeleton/skeleton';
import ProfileImageLoading from 'buyside/components/presentation/ProfileImage/profileImageLoading';

import styles from './onboardingCommunitySuggestionCardStyles.scss';

const OnboardingFundRecommendationCardLoading: React.FC = () => (
  <div className={styles.communityCardContainer}>
    <div className={styles.communityCard}>
      <div className={styles.flexFundCard}>
        <div className={styles.fundName}>
          <ProfileImageLoading className={styles.fundImage} />
        </div>
        <Skeleton size={SKELETON_SIZES.LARGE} />
        <Skeleton size={SKELETON_SIZES.LARGE} />
        <Skeleton size={SKELETON_SIZES.LARGE} />
        <div className={classnames(styles.watchlistedSectors, styles.skeletonText)}>
          Based on your fund preferences
          <div className={styles.sectors}>
            <Skeleton width={SKELETON_WIDTHS.SMALL} />
            <Skeleton width={SKELETON_WIDTHS.SMALL} />
          </div>
        </div>
        <div className={styles.fundDetails}>
          <div className={styles.fundDetailItem}>
            <div className={styles.skeletonText}>Return LTM</div>
            <Skeleton width={SKELETON_WIDTHS.SMALL} />
          </div>
          <div className={styles.fundDetailItem}>
            <div className={styles.skeletonText}>Return YTD</div>
            <Skeleton width={SKELETON_WIDTHS.SMALL} />
          </div>
          <div className={styles.fundDetailItem}>
            <div className={styles.skeletonText}>Return since</div>
            <Skeleton width={SKELETON_WIDTHS.SMALL} />
          </div>
          <div className={styles.fundDetailItem}>
            <div className={styles.skeletonText}>Focus</div>
            <Skeleton width={SKELETON_WIDTHS.SMALL} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default OnboardingFundRecommendationCardLoading;
